import {
  Category,
  CategoryCreate,
  CategoryEdit,
  CategoryList,
} from '../pages/Inventory/Category';
import { Inventories } from '../pages/Inventory/Inventories';
import {
  ProductandServices,
  ProductCreate,
  ProductDetails,
  ProductEdit,
  ProductList,
} from '../pages/Inventory/Product';

export const inventories = {
  path: 'inventory',
  element: <Inventories />,
  children: [
    {
      path: 'categories',
      element: <Category />,
      children: [
        { index: true, element: <CategoryList /> },
        { path: 'create', element: <CategoryCreate /> },
        { path: ':id/edit', element: <CategoryEdit /> },
      ],
    },
    {
      path: 'products-and-services',
      element: <ProductandServices />,
      children: [
        { index: true, element: <ProductList /> },
        { path: 'create', element: <ProductCreate /> },
        { path: ':id/details', element: <ProductDetails /> },
        { path: ':id/edit', element: <ProductEdit /> },
      ],
    },
  ],
};
